/* Print Phuket Shop by Business pages (17 Oct 2026): header-aware jump links + one page-view event for ads/analytics. */
(function () {
  var root = document.querySelector('[data-ppi]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function headerOffset() {
    var b = 0;
    document.querySelectorAll('.shopify-section-group-header-group,header.header').forEach(function (e) {
      var r = e.getBoundingClientRect(), p = getComputedStyle(e).position;
      if ((p === 'sticky' || p === 'fixed') && r.top <= b + 1 && r.bottom > b && r.height < 300) b = r.bottom;
    });
    return b;
  }
  root.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-ppi-jump]');
    if (!a) return;
    var id = (a.getAttribute('href') || '').slice(1);
    var t = id && document.getElementById(id);
    if (!t) return;
    e.preventDefault();
    var y = t.getBoundingClientRect().top + window.scrollY - headerOffset() - 12;
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
    try { history.replaceState(null, '', '#' + id); } catch (x) {}
  });
  var payload = { industry: root.getAttribute('data-industry') || '' };
  try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'pp_industry_view' }, payload)); } catch (x) {}
  try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish('pp_industry_view', payload); } catch (x) {}
})();
